<template>
  <div class="system">
    <page-list-container
      :total="total"
      :pageSize="pageSize"
      :inputCurrentPage="currentPage"
      @onPageChange="onPageChange"
      @onSizeChange="onSizeChange"
    >
      <el-table 
        :data="dataArray" 
        style="width: 100%;"
        :header-cell-style="{
          background: '#fafafa',
          color: '#333',
          fontWeight: 400,
          height: '54px'
        }"
      >
        <el-table-column prop="trueName" label="姓名" min-width="100" align="center"></el-table-column>
        <el-table-column prop="schoolName" label="学校名" min-width="180" align="center"></el-table-column>
        <el-table-column prop="grade" label="年级" min-width="100" align="center"></el-table-column>
        <el-table-column prop="gradeName" label="班级" min-width="120" align="center"></el-table-column>
        <el-table-column prop="psqScore" label="PSQ得分" min-width="100" align="center"></el-table-column>
        <el-table-column prop="osaScore" label="OSA-18得分" min-width="100" align="center"></el-table-column>
        <el-table-column prop="spo2min" label="最低血氧饱和度" min-width="130" align="center"></el-table-column>
        <el-table-column label="操作" min-width="200" align="center">
          <template slot-scope="scope">
            <div class="cell-unit-operation-content">
            <cell-unit title="查看" :validIconSRC="previewValidSRC" :inValidIconSRC="previewInvalidSRC"
          isValid @onClick="handleView(scope.row)"></cell-unit>
          <div class="cell-unit-operation-content-slash"></div>
          <cell-unit title="下载" :validIconSRC="downloadValidSRC" :inValidIconSRC="downloadInvalidSRC"
          isValid @onClick="handleDownload(scope.row)"></cell-unit>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </page-list-container>
  </div>
</template>

<script>
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";
import { DateTool } from "@js/date-tool.js";

import { downloadExportFile } from "@js/report-export-tool.js";
import { Button } from 'element-ui'
import CellUnit from "@c/report/sleep-report/cell-unit.vue";
import { ReportPreviewTool } from "@js/report-preview-tool.js";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export default {
  components: {
    PageListContainer,
    ElButton: Button,
    CellUnit
  },

  props: {
    componentDuration: Object,
    schoolId: {
      type: [String, Number, null],
      default: null
    },
    gradeId: {
      type: [String, Number, null],
      default: null
    },
    classId: {
      type: [String, Number, null],
      default: null
    },
    hasRingReport: {
      type: [Number, undefined],
      default: undefined
    }
  },

  data() {
    return {
      dataArray: [],
      total: 0,
      pageSize: undefined,
      currentPage: 1,
      keywords: undefined,

      cascadeSchoolId: null,
      cascadeGradeId: null,
      cascadeClassId: null,

      previewValidSRC: require("@imgs/report-preview.png"),
      previewInvalidSRC: require("@imgs/report-preview-gray.png"),
      downloadValidSRC: require("@imgs/report-download.png"),
      downloadInvalidSRC: require("@imgs/report-download-gray.png"),
    };
  },

  computed: {
    hospitalID() {
      return this.$store.state.selectedHospital.hospitalid;
    }
  },

  watch: {
    hospitalID() {
      this.currentPage = 1;
      this.getReportList();
    },

    componentDuration() {
      this.currentPage = 1;
      this.getReportList();
    },

    schoolId() {
      this.cascadeSchoolId = this.schoolId;
    },
    gradeId() {
      this.cascadeGradeId = this.gradeId;
    },
    classId() {
      this.cascadeClassId = this.classId;
    },
    hasRingReport() {
      this.getReportList();
    }
  },

  mounted() {
    this.pageSize = bestPageSizeComputer();
    this.getReportList();
  },

  methods: {

    //分页
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.getReportList();
    },

    onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getReportList();
    },

    onSearchClick(keywords) {
      this.keywords = keywords;
      this.currentPage = 1;
      this.getReportList();
    },

    onCascadeSearch(cascadeParams) {
      this.cascadeSchoolId = cascadeParams.schoolName;
      this.cascadeGradeId = cascadeParams.grade;
      this.cascadeClassId = cascadeParams.gradeName;
      this.currentPage = 1;
      this.getReportList();
    },

    // method
    async getReportList() {
      const params = {
        hospitalId: this.hospitalID == 0 ? null : this.hospitalID,
        keyword: this.keywords,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        start: DateTool.timestampToStr(
          this.componentDuration.startTime,
          "Y-M-D h:m:s"
        ),
        end: DateTool.timestampToStr(
          this.componentDuration.endTime,
          "Y-M-D h:m:s"
        ),
        schoolName: this.cascadeSchoolId,
        grade: this.cascadeGradeId,
        gradeName: this.cascadeClassId,
        hasRingReport: this.hasRingReport
      };

      try {
        const data = await this.$api.assessmentResultLiangXiangPageList(params);
        this.dataArray = data.list;
        this.total = data.total;
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    // 查看详情
    handleView(row) {
      // TODO: 实现查看详情的逻辑
      console.log('查看详情', row);
      ReportPreviewTool.previewLiangXiangReport(
        row.uid
      );
    },

    // 下载报告
    async handleDownload(row) {
      try {
        const params = {
        uid: row.uid
      };
      const response = await this.$api.downloadLiangXiangAssessmentPdf(params)
      window.open(response)
      } catch (error) {

      }
    },
    async exportReport() { 
      try {
        const response = await this.$api.exportLiangXiangAssessmentExcel({})
        downloadExportFile(response);
      } catch (error) {

      }
    },

    async exportPdfBatch() {
      try {
        this.$store.state.loadingShow = true;

        // Fetch all data with pageSize = 10000
        const params = {
          hospitalId: this.hospitalID == 0 ? null : this.hospitalID,
          keyword: this.keywords,
          pageNum: 1,
          pageSize: 10000,
          start: DateTool.timestampToStr(
            this.componentDuration.startTime,
            "Y-M-D h:m:s"
          ),
          end: DateTool.timestampToStr(
            this.componentDuration.endTime,
            "Y-M-D h:m:s"
          ),
          schoolName: this.cascadeSchoolId,
          grade: this.cascadeGradeId,
          gradeName: this.cascadeClassId,
          hasRingReport: this.hasRingReport
        };

        const data = await this.$api.assessmentResultLiangXiangPageList(params);
        let exportDataArray = data.list;

        if (!exportDataArray || exportDataArray.length === 0) {
          this.$store.state.loadingShow = false;
          this.$toast.showRed('没有可导出的数据');
          return;
        }
        
        const zip = new JSZip();
        const folder = zip.folder([this.schoolId, this.classId].filter(Boolean).join('_'));

        const fetchPromises = exportDataArray.map(async (item, index) => {
          if (item.reportPdfUrl) {
            try {
              const response = await fetch(item.reportPdfUrl);
              const blob = await response.blob();
              // Check if there are duplicate names, add UID only for duplicates
              const isDuplicate = exportDataArray.filter(i => i.trueName === item.trueName).length > 1;
              const fileName = isDuplicate 
                ? `${item.trueName || '学生'}_${item.schoolName || ''}_${item.gradeName || ''}_${item.uid}.pdf`
                : `${item.trueName || '学生'}_${item.schoolName || ''}_${item.gradeName || ''}.pdf`;
              folder.file(fileName, blob);
            } catch (err) {
              console.error(`Failed to fetch PDF for ${item.trueName}:`, err);
            }
          }
        });

        await Promise.all(fetchPromises);

        const zipBlob = await zip.generateAsync({ type: 'blob' });
        const zipFileName = [this.schoolId, this.classId].filter(Boolean).join('_');
        const finalFileName = zipFileName ? `${zipFileName}.zip` : `评估报告_${new Date().getTime()}.zip`;
        saveAs(zipBlob, finalFileName);
        
        this.$store.state.loadingShow = false;
        this.$toast.showGreen('PDF打包下载成功');
      } catch (error) {
        this.$store.state.loadingShow = false;
        this.$toast.showRed('PDF打包下载失败: ' + error.message);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.system {
  font-size: 19px;
  width: 100%;
  height: 100%;
  :deep(.el-table)::before{
    display: none;
  }
  :deep(.el-table__empty-block) {
    display: none;
  }
  .cell-unit-operation-content {
    display: flex;
    justify-content: center;
      &-slash {
        background-color: #e9e9e9;
        width: rem(1);
        height: rem(14);
        margin-left: rem(10);
        margin-right: rem(10);
      }
  }
}
</style>
